module.exports = __webpack_public_path__ + "static/media/oxygen7-logo-white.8d0fc59b.png";